import ZButton from "@atoms/ZButton";
import { EColors } from "@atoms/ZColors/interface";
import ZIcon from "@atoms/ZIcon";
import { EIcons } from "@atoms/ZIcon/interface";
import { Skeleton } from "antd";
import React, { FC, memo, useState } from "react";
import { Droppable } from "react-beautiful-dnd";
import ZDraggableCard from "../ZDraggableCard";
import { IStageColumn } from "./interface";

const ZStageColumn: FC<IStageColumn> = ({
	index,
	count = 0,
	stageId,
	handleFetchMoreClick,
	isStageColumnLoading,
	opportunities
}) => {
	const arraySize = index === 0 ? 3 : index === 1 ? 2 : 1;
	const [loading, setLoading] = useState<boolean>(false);
	const [pageNumber, setPageNumber] = useState<number>(1);
	const loadMoreOpportunities = async () => {
		try {
			setLoading(true);
			setPageNumber(prev => prev + 1);
			await handleFetchMoreClick(pageNumber + 1);
		} finally {
			setLoading(false);
		}
	};
	return (
		<Droppable droppableId={`OPPORTUNITY_STAGE::${stageId}`}>
			{(provided, snapshot) => (
				<div
					ref={provided.innerRef}
					{...provided.droppableProps}
					className={`transition-colors p-2 ${
						snapshot.isDraggingOver ? "bg-gray-4" : ""
					}`}
					style={{ height: "calc(100% - 84px)" }}
				>
					{isStageColumnLoading
						? [...new Array(arraySize)].map((_x, index) => (
								<div
									key={index}
									className="bg-gray-1 p-3 mb-3 rounded"
									style={{ height: 150 }}
								>
									<Skeleton
										loading={true}
										active
										title={true}
										paragraph={{
											rows: 2,
											width: "100%"
										}}
									/>
								</div>
						  ))
						: opportunities.map(opportunity => (
								<ZDraggableCard
									{...opportunity}
									key={opportunity.opportunityId}
								/>
						  ))}
					{provided.placeholder}
					{opportunities.length < count && !!count && (
						<ZButton
							onClick={loadMoreOpportunities}
							loading={loading}
							className="m-auto block mt-2"
							icon={
								<ZIcon
									name={EIcons.CHEVRONDOWN}
									size="sm"
									className="mr-2"
									color={EColors.BLUE}
									colorVariant={6}
								/>
							}
							type="link"
						>
							{loading ? "Loading..." : "Load more"}
						</ZButton>
					)}
				</div>
			)}
		</Droppable>
	);
};

export default memo(ZStageColumn);
